module.exports = __webpack_public_path__ + "static/media/status.76f943fb.svg";